/**
 * SegmentedControl , Mild | Moderate | Severe style toggle.
 * Mobile-friendlier than a hidden <select>.
 */
export function SegmentedControl({
  options = [],
  value,
  onChange,
  ariaLabel,
  "data-testid": testId,
}) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      data-testid={testId}
      className="inline-flex w-full p-1 bg-[var(--bone-soft)] rounded-lg border border-[var(--light-border)]"
    >
      {options.map((opt) => {
        const v = typeof opt === "string" ? opt : opt.value;
        const label = typeof opt === "string" ? opt : opt.label;
        const selected = v === value;
        return (
          <button
            type="button"
            key={v}
            role="radio"
            aria-checked={selected}
            onClick={() => onChange?.(v)}
            data-testid={testId ? `${testId}-${v}` : undefined}
            className={`flex-1 px-3 py-2 rounded-md text-sm font-medium transition-all ${
              selected
                ? "bg-white text-[var(--charcoal)] shadow-sm"
                : "text-[var(--text-muted)] hover:text-[var(--charcoal)]"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
